import { set, get, clone } from "lodash";
import servicesUtils from "../../../utils/servicesUtils";

const getPatientsV2 = (apiParams = {}, prevData, apiConfig = {}) => {
  const prevPage = get(prevData, ["data", "content"], []);
  const prevLastId = get(prevData, ["data", "last_id"], "");
  const { search, pagination_id } = apiParams;

  return new Promise((resolve, reject) => {
    servicesUtils
      .postService("/patients/v2/", apiParams, apiConfig)
      .then((data) => {
        const newData = clone(data);
        let newPage = get(newData, ["data", "content"], []);
        const newLastId = get(newData, ["data", "last_id"], "");
        if (prevLastId !== newLastId || search) {
          if (pagination_id) {
            newPage = [...prevPage, ...newPage];
          }
          set(newData, ["data", "content"], newPage);
        }
        resolve(newData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default getPatientsV2;
